<template>
  <div>
    <b-card>
      <div class="text-right">
        <feather-icon class="cursor-pointer" size="21" icon="LogOutIcon" @click="logout"/>
        <span class="cursor-pointer"  @click="logout"> 退出</span>
      </div>
      <h4 class="pt-1">运单号</h4> <!-- Tracking -->
      <b-form-input v-model="tracking" @keypress.enter="srchTrack"/>
      <b-button
        class="mt-1"
        variant="primary"
        @click="srchTrack"
        :disabled="this.loadBtn == false"
      >
        <b-spinner v-if="this.loadBtn == false" small/>
        <!-- ค้นหา -->
        查询
      </b-button>
      <hr>
      <div v-if="this.hidden == false">
        <b-row>
          <b-col class="pr-0">
            <b-form-file
              v-model="imgFile"
              placeholder="正在上传"
              drop-placeholder="วางรูปภาพที่นี่"
            />
          </b-col>
          <b-col class="text-right pl-0">
            <b-button
              variant="success"
              @click="saveImg"
              :disabled="this.loadBtnSave == false"
            >
              <b-spinner v-if="this.loadBtnSave == false" small/>
              保存 <!-- บันทึก -->
            </b-button>
          </b-col>
        </b-row>
        <b-row class="pt-2">
          <b-col v-for="(item,index) in imgList" :key="index" class="col-6">
            <span v-if="item.img64 != null">
              <div class="text-right cursor-pointer" @click="removeImg(item)">
                <feather-icon icon="XIcon" size="21"/>
              </div>
              <b-img :src="item.img64" fluid width="200px"></b-img>
            </span>
          </b-col>
        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BRow, BCol, BFormGroup, BFormInput, BFormCheckbox, BForm, BButton, BCard, BTabs, BTab, BCardBody, BInputGroup,
  BFormSpinbutton, BFormTextarea, BFormFile, BOverlay, BSpinner, BImg, BCardText, BLink, BDropdown, BDropdownItem,
  BFormRadioGroup, BFormCheckboxGroup, BAlert, BInputGroupPrepend, BInputGroupAppend, BContainer, BNav, BNavItem,
  BNavbarNav, BAvatar, BFormRadio, BModal, BTooltip
} from 'bootstrap-vue'
import { initialAbility } from '@/libs/acl/config'
import useJwt from '@/auth/jwt/useJwt'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import axios from "axios";
import {header_token} from '@/views/token.js'
import {taobaoService_dotnet} from '@/views/global.js'
export default {
  name: 'Taobao2youTracking',

  components: {
    BRow, BCol, BFormGroup, BFormInput, BFormCheckbox, BForm, BButton, BCard, BTabs, BTab, BCardBody, BInputGroup,
    BFormSpinbutton, BFormTextarea, BFormFile, BOverlay, BSpinner, BImg, BCardText, BLink, BDropdown, BDropdownItem,
    BFormRadioGroup, BFormCheckboxGroup, BAlert, BInputGroupPrepend, BInputGroupAppend, BContainer, BNav, BNavItem,
    BNavbarNav, BAvatar, BFormRadio, BModal, BTooltip
  },

  data() {
    return {
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      tracking: '',
      imgFile: null,
      imgList: [],
      imgUrlList: [],
      hidden: true,

      loadBtn: true,
      loadBtnSave: true,
    };
  },

  watch: {
    async imgFile() {
      var fileBase64 = null
      const toBase64 = file => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
      });
      if (this.imgFile!=null && this.imgFile!=undefined) {
        fileBase64 = await toBase64(this.imgFile)
        this.imgList.push({
          'img64': fileBase64,
          'img': this.imgFile
        })
      }
    },
  },

  methods: {
    async srchTrack() {
      this.loadBtn = await false
      //clear value
      await this.clearValue()

      //coding
      let response = await axios.get(
        taobaoService_dotnet + 'China/search-tracking-photo?TrackingNo=' + this.tracking,
        { headers: header_token }
      );
      if (response.data.photoList != null) {
        response.data.photoList.forEach((e) => {
          this.imgList.push({
            'img64': e,
            'img': null
          })
        });
      }
      if (this.tracking != '') {
        this.hidden = false
      } else {
        this.hidden = true
      }
      this.loadBtn = await true
    },
    async saveImg() {
      this.loadBtnSave = await false
      if (this.tracking == '') {
        this.$swal({
          position: 'top',
          title: '运单号错误!', //Tracking ไม่ถูกต้อง!
          text: '重新查询运单号', //กรุณาค้นหาเลข Tracking ใหม่
          icon: 'warning',
          confirmButtonText: '确认',
          customClass: {
            confirmButton: 'btn btn-primary',
            text: 'text-danger'
          },
          buttonsStyling: false,
        })
      } else if (this.imgList.length > 0) {
        for (let index = 0; index < this.imgList.length; index++) {
          if (this.imgList[index].img != null) {
            await this.addPhoto(this.imgList[index].img)
          } else {
            this.imgUrlList.push(this.imgList[index].img64)
          }
        }

        let response = await axios.post(
          taobaoService_dotnet + 'China/update-tracking-photo',
          {
            "trackingNo": this.tracking,
            "userID": this.userInfo.data.userid,
            "photoList": this.imgUrlList
          },
          { headers: header_token }
        );
        if (response.data.status == "success") {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: '完成', //สำเร็จ
              icon: 'CheckIcon',
              text: '保存图片成功', //บันทึกรูปภาพสำเร็จ
              variant: 'success',
            },
          }, { position: 'top-center' })
          //clear value
          this.tracking = ''
          this.imgUrlList = []
          this.clearValue()
        }
      } else {
        this.$swal({
          position: 'top',
          title: '没有上传图片!', //คุณไม่ได้อัปโหลดรูปภาพ!
          text: '请上传图片', //กรุณาอัปโหลดรูปภาพ
          icon: 'warning',
          customClass: {
            confirmButton: 'btn btn-primary',
            text: 'text-danger'
          },
          buttonsStyling: false,
        })
      }
      this.loadBtnSave = await true
    },
    async removeImg(info) {
      this.imgList = this.imgList.filter(function(item) {
        return item !== info
      })
    },
    async addPhoto(item) {
      var imgLink = null
      var FormData = require('form-data');
      var data = new FormData();
      data.append('', item);
      var config = {
        method: 'post',
        url: taobaoService_dotnet + 'api/General/upload-file-with-type?UploadType=11',
        headers: {
          'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIwIiwibmFtZSI6InRhb2JhbzJ5b3UiLCJyb2xlIjoiYWRtaW4iLCJjdXN0b21lcmlkIjoiIiwiZXhwIjoxNjI2MTAyNzgwLCJpc3MiOiJ0YW9iYW8yeW91IiwiYXVkIjoiaHR0cHM6Ly93d3cudGFvYmFvMnlvdS5jb20ifQ.gIhTvIMLXxpq6bUFPbp242szDgPRl33SaF3k5f6T3-U',
          'Content-Type': 'application/json',
        },
        data : data
      };
      await axios(config)
      .then(function (response) { imgLink = response.data })
      .catch(function (error) { console.log(error); });
      this.imgUrlList.push(imgLink[0])
    },
    clearValue() {
      this.imgFile = null
      this.imgList = []
      this.hidden = true
    },
    logout() {
      // Remove userData from localStorage
      // ? You just removed token from localStorage. If you like, you can also make API call to backend to blacklist used token
      // localStorage.removeItem(useJwt.jwtConfig.storageTokenKeyName)
      // localStorage.removeItem(useJwt.jwtConfig.storageRefreshTokenKeyName)

      // Remove userData from localStorage
      localStorage.removeItem('userInfo')

      // Reset ability
      this.$ability.update(initialAbility)

      // Redirect to login page
      this.$router.push({ name: 'tracking-login' })
    }
  },
};
</script>

<style lang="scss" scoped>

</style>